module.exports = __webpack_public_path__ + "static/desktop/img/calendar-2.44a0c559.png";